import { Box, Text } from '@bpba/ui-components';
import { IFixedTermItem } from '../types/IFixedTermItem';
import { PlazoFijoItem } from './PlazoFijoItem';
import { TABLE_EMPTY_FIXED_TERMS } from '../constants/data';

type PlazosFijosListProps = {
  data: IFixedTermItem[] | undefined;
};

export const PlazosFijosList = ({ data }: PlazosFijosListProps) => {
  if (!data || data.length === 0) return <Text opacity={0.8} margin="auto" marginTop={['48px']} dangerouslySetInnerHTML={{ __html: TABLE_EMPTY_FIXED_TERMS }} />;

  return (
    <Box flexDirection={'column'} display={['flex']}>
      {data.map((item, key) => (
        <PlazoFijoItem data={item} key={key} />
      ))}
    </Box>
  );
};
